export function useSlideTitle() {
  return "CBOT forward curve";
}